import { VisitCompletionType } from "./VisitCompletionType";

export enum AppointmentStatus {
    Invalid = 0,
    Booked = 1,
    Confirmed = 2,
    Cancelled = 3,
    Rescheduled = 4,
    Showed = 5,
    ClinicCancelled = 7,
    NoShow = 8,
    In_Progress = 9,
    Admitted = 10,
    Finalized = 11,
    Paid = 12,
    Check_In = 500,
    Consultation = 501,
    VetServices = 502,
    Check_Out = 503,
    Walk_In = 9999 // UI only Appointment Status that maps to "Showed" with a Reservation Trait of: Reservation - Walk In
}

export namespace AppointmentStatus {
    export const statusFormattedName = (status: string | number | undefined, visitCompletionTypeId?: number | undefined) => {
        if (typeof status === 'number') status = AppointmentStatus[status];
        if (!status) return "Unknown";

        switch (status) {
            case "Check_In": return "Checked-in";
            case "In_Progress": return "In Progress";
            case "VetServices": return "Vet Services";
            case "Check_Out":
                if (VisitCompletionType.visitIsAborted(visitCompletionTypeId)) return "Aborted";
                else return "Completed";
            case "ClinicCancelled": return "Clinic Cancelled";
            case "NoShow": return "No Show";
            default: return status; // Booked, Confirmed, Completed, Cancelled
        }
    }

    export const cssFormattedStatus = (status: string | number | undefined) => {
        if (typeof status === 'number') status = AppointmentStatus[status];
        if (!status) return "Unknown";

        switch (status) {
            case "In_Progress": return "inprogress";
            case "Check_In": return "checkedin";
            default:
                return status;
        }
    }

    export const statusIcon = (status: string | number | undefined, visitCompletionTypeId?: number | undefined) => {
        if (typeof status === 'number') status = AppointmentStatus[status];
        if (!status) return "Unknown";

        switch (status) {
            case "Booked": return "fa fa-calendar";
            case "Rescheduled": return "fa fa-rotate-right";
            case "Confirmed": return "fa fa-check";
            case "Showed": return "fa fa-thumbs-o-up";
            case "Check_In": return "fa fa-thumbs-o-up";
            case "In_Progress": return "fa fa-clock-o";
            case "Consultation": return "fa fa-clock-o";
            case "Admitted": return "fa fa-clock-o";
            case "VetServices": return "fa fa-clock-o";
            case "Check_Out":
                if (VisitCompletionType.visitIsAborted(visitCompletionTypeId)) return "fa fa-times";
                else return "fa fa-check-square-o";
            case "Finalized": return "fa fa-check-square-o";
            case "Paid": return "fa fa-check-square-o";
            case "Cancelled": return "fa fa-times";
            case "NoShow": return "fa fa-times";
            case "ClinicCancelled": return "fa fa-times";
            default: return "";
        }
    }

    export const showAsDormant = (status: AppointmentStatus) => {
        return status === AppointmentStatus.NoShow || status === AppointmentStatus.Paid || status === AppointmentStatus.Check_Out;
    }
}
